export function parseScoreChange(behaviorScoreChange) {
  if (behaviorScoreChange > 0) return `+ ${behaviorScoreChange}`
  if (behaviorScoreChange < 0) return `- ${behaviorScoreChange * -1}`
  return behaviorScoreChange
}
